import Mock from "../mock";

const database = {
  information: {
    name: 'Shafiul Alam',
    aboutContent: "I’m a Front-End Developer located in Poland. I have a serious passion for UI effects, animations and creating intuitive, dynamic user experiences.",
    age: '22',
    phone: '+8801799345499',
    nationality: 'Bangladeshi',
    language: 'English',
    email: 'shafiulalam.sra@gmail.com',
    address: 'ashulia, savar, Dhaka',
    freelanceStatus: 'Available',
    weblogo: 'Antor.dev',
    socialLinks: {
      facebook: 'https://fb.com/hearts.antor3',
      twitter: 'https://twitter.com/heartsantor',
      pinterest: '',
      behance: '',
      linkedin: 'https://www.linkedin.com/in/shafiul-alam-b0b203154',
      dribbble: '',
      github: 'https://github.com/heartsantor'
    },
    // brandImage: '/images/brand-image.jpg',
    // aboutImage: '/images/about-image.jpg',
    // aboutImageLg: '/images/about-image-lg.jpg',
    cvfile: ''
  },
  services: [
    {
      title: "Front-End developer",
      icon: 'color-pallet',
      details: "I FrontEnd developer with excellent work ethic. Any work, even the most simple, must be clearly completed and timely."
    },
    {
      title: "Full stack developer",
      icon: 'code',
      details: "Creative brand, website design and development studio that can bring your online business dreams to life"
    },
    // {
    //   title: "Mobile Development",
    //   icon: 'mobile',
    //   details: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem tenetur ratione quod."
    // }

  ],
  reviews: [
    {
      id: 1,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam, aliquid maxime tempora.",
      author: {
        name: 'Burdette Turner',
        designation: 'Web Developer, Abc Company'
      }
    },
    {
      id: 2,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Expedita impedit nobis tempore quaerat quibusdam.",
      author: {
        name: 'Susan Yost',
        designation: 'Client'
      }
    },
    {
      id: 3,
      content: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
      author: {
        name: 'Irving Feeney',
        designation: 'Fiverr Client'
      }
    }
  ],
  skills: [
    // {
    //   title: "Wordpress",
    //   icon: "wordpress",
    //   type: "brand"

    // },
    {
      title: "React.js",
      icon: "react",
      type: "brand"
    },
    {
      title: "Redux",
      icon: "battle-net",
      type: "brand"
    },
    {
      title: "Node.js",
      icon: "node-js",
      type: "brand"
    },
    {
      title: "HTML5",
      icon: "html5",
      type: "brand"
    },
    {
      title: "CSS3",
      icon: "css3",
      type: "brand"
    },
    {
      title: "SASS",
      icon: "sass",
      type: "brand"
    },
    {
      title: "Javascript",
      icon: "js",
      type: "brand"
    },
    {
      title: "Bootstrap",
      icon: "bootstrap",
      type: "brand"
    },

  ],
  portfolios: [
    {
      id: 10,
      title: "Pinktada",
      subtitle: "Landing page using using React js",
      imageUrl: "/images/protfolio/pinktada/title.png",
      largeImageUrl: [
        "/images/protfolio/pinktada/des2.png",
        "/images/protfolio/pinktada/des1.png",
        "/images/protfolio/pinktada/des3.png",
        // "/images/protfolio/pinktada/des4.png",
        // "/images/protfolio/pinktada/des5.png",
      ],
      url: 'https://pinktada.com/'
    },
    {
      id: 7,
      title: "TuneIn",
      subtitle: "Audio stremming web using React js",
      imageUrl: "/images/protfolio/tunein/title.png",
      largeImageUrl: [
        "/images/protfolio/tunein/des1.png",
        "/images/protfolio/tunein/des2.png",
        "/images/protfolio/tunein/des3.png",
        // "/images/protfolio/tunein/des4.png",
      ],
      url: 'https://tunein.vercel.app/'
    },
    {
      id: 6,
      title: "Harissa",
      subtitle: "OnBoard management System using React js",
      imageUrl: "/images/protfolio/harissa/title.png",
      largeImageUrl: [
        "/images/protfolio/harissa/des1.png",
        "/images/protfolio/harissa/des2.png",
        "/images/protfolio/harissa/des3.png",
        // "/images/protfolio/harissa/des4.png",
      ],
      url: 'https://harissa.vercel.app/'
    },
    {
      id: 5,
      title: "Notary",
      subtitle: "Management System using React js",
      imageUrl: "/images/protfolio/notary/title.png",
      largeImageUrl: [
        "/images/protfolio/notary/des1.png",
        "/images/protfolio/notary/des2.png",
        "/images/protfolio/notary/des3.png",
        // "/images/protfolio/harissa/des4.png",
      ],
      url: 'https://notary-roan.vercel.app/'
    },
    {
      id: 4,
      title: "Safe-Transport System",
      subtitle: "Landing page for Transport System using React js",
      imageUrl: "/images/protfolio/transport/title.png",
      largeImageUrl: [
        "/images/protfolio/transport/des1.png",
        "/images/protfolio/transport/des2.png",
        "/images/protfolio/transport/des3.png",
      ],
      url: 'https://antor.dev'
    },
    {
      id: 3,
      title: "Web Devoloper Protfolio",
      subtitle: "Protfolio using React js",
      imageUrl: "/images/protfolio/my/title.png",
      largeImageUrl: [
        "/images/protfolio/my/des1.png",
        "/images/protfolio/my/des2.png",
        "/images/protfolio/my/des3.png",
        // "/images/protfolio/my/des4.png",
        // "/images/protfolio/my/des5.png",
      ],
      url: 'https://my-protfilio-clone.vercel.app/'
    },
    {
      id: 2,
      title: "AirBnb Sample",
      subtitle: "Landing page using tailwind css and Next Js",
      imageUrl: "/images/protfolio/airbnb/title.png",
      largeImageUrl: [
        "/images/protfolio/airbnb/des.png"
      ],
      url: 'https://clone-airbnb-two.vercel.app/'
    },
    {
      id: 1,
      title: "Ui Lib Test",
      subtitle: "A beautiful Ui using Material UI",
      imageUrl: "/images/protfolio/uilib/title.png",
      largeImageUrl: ["/images/protfolio/uilib/des.png"],
      url: 'https://test-project-ui-lib.vercel.app/'
    },

  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "2018 - Present",
        position: "Frontend Web Developer",
        company: "Abc Company",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      },
      {
        id: 2,
        year: "2016 - 2018",
        position: "Frontend Web Developer",
        company: "CBA Company",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      },
      {
        id: 3,
        year: "2014 - 1016",
        position: "UI/UX Designer",
        company: "Example Company",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      }
    ],
    educationExperience: [
      {
        id: 1,
        year: "2018 - 2019",
        graduation: "Master of Science",
        university: "Abc University",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      },
      {
        id: 2,
        year: "2016 - 2018",
        graduation: "Bachelor of Science",
        university: "Abc University",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      },
      {
        id: 3,
        year: "2015 - 2016",
        graduation: "Higher Schoold Graduation",
        university: "Abc College",
        details: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, aspernatur consequatur accusamus vero eum facere exercitationem velit suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. Molestiae, vel porro."
      }
    ]
  },
  // blogs: [
  //   {
  //     id: 1,
  //     title: 'Markdown & Html supported blog.',
  //     featuredImage: '/images/blog-image-1.jpg',
  //     filesource: '../../blog/markdown-html-supported-blog.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 2,
  //     title: 'Installing NodeJS on your device.',
  //     featuredImage: '/images/blog-image-2.jpg',
  //     filesource: '../../blog/installing-nodejs-on-your-device.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 3,
  //     title: 'UI/UX design starter with Adobe XD.',
  //     featuredImage: '/images/blog-image-3.jpg',
  //     filesource: '../../blog/uiux-design-starter-with-adobe-xd.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 4,
  //     title: 'Boost your post for increasing sales.',
  //     featuredImage: '/images/blog-image-4.jpg',
  //     filesource: '../../blog/boost-your-post-for-increasing-sales.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 5,
  //     title: 'Difference between GatsbyJS & NextJS.',
  //     featuredImage: '/images/blog-image-5.jpg',
  //     filesource: '../../blog/difference-between-gatsbyjs-and-nextjs.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 6,
  //     title: 'How to choose javascript framework for project.',
  //     featuredImage: '/images/blog-image-6.jpg',
  //     filesource: '../../blog/how-to-choose-javascript-framework-for-project.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 7,
  //     title: 'Web automation with python language.',
  //     featuredImage: '/images/blog-image-7.jpg',
  //     filesource: '../../blog/web-automation-with-python-language.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 8,
  //     title: 'Time to use latest technology for creating a website.',
  //     featuredImage: '/images/blog-image-8.jpg',
  //     filesource: '../../blog/time-to-use-latest-technology-for-creating-a-website.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 9,
  //     title: 'Think out of the box.',
  //     featuredImage: '/images/blog-image-9.jpg',
  //     filesource: '../../blog/think-out-of-the-box.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 10,
  //     title: 'Trending designs in 2020.',
  //     featuredImage: '/images/blog-image-1.jpg',
  //     filesource: '../../blog/trending-designs-in-2020.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 11,
  //     title: 'How to get 10k instagram followers?',
  //     featuredImage: '/images/blog-image-2.jpg',
  //     filesource: '../../blog/how-to-get-10k-instagram-followers.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 12,
  //     title: 'What NodeJS can do?',
  //     featuredImage: '/images/blog-image-3.jpg',
  //     filesource: '../../blog/what-nodejs-can-do.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 13,
  //     title: 'Futures of javascript.',
  //     featuredImage: '/images/blog-image-4.jpg',
  //     filesource: '../../blog/future-of-javascript.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 14,
  //     title: 'Popular javascript library in 2020.',
  //     featuredImage: '/images/blog-image-5.jpg',
  //     filesource: '../../blog/popular-javascript-library-in-2020.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   },
  //   {
  //     id: 15,
  //     title: 'Programmers must read books.',
  //     featuredImage: '/images/blog-image-6.jpg',
  //     filesource: '../../blog/programmers-must-read-books.md',
  //     createDay: "20",
  //     createMonth: 'February',
  //     createYear: "2020"
  //   }
  // ],
  contactInfo: {
    phoneNumbers: ['+8801799345499', '+8809696345499'],
    emailAddress: ['me@antor.dev', 'shafiulalam,sra@gmail.com'],
    address: "ashulia, savar, Dhaka"
  }
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});

// Mock.onGet("/api/blog").reply(config => {
//   const response = database.blogs;
//   return [200, response];
// });

Mock.onGet("/api/contactinfo").reply(config => {
  const response = database.contactInfo;
  return [200, response];
});